/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import request from "../../request";
import { updateObjectByPath } from "../utils";
import { withPropertyData } from "../../../../components/property-admin-data-provider";
import Cookies from "js-cookie";

//When on list view, when the switch is triggered
//this function is executed, it changes the boolean active
//field property of the entity (it can have different names
//for different entities, so it should be configurable)
//It does so by making an edit to the entity and sending
//an update request to the API, which if successful triggers a reload of the
//entities for the list. if not successful it shows an error.
//@param {Number} a
//@param {Number} b
//@return {Number} sum
async function onToggleListItem({
  id,
  entity,
  activeProperty,
  restConfig,
  sendRequest,
  beforePromise,
  requestObjectActiveProperty: otherProperty,
  binary,
}) {
  if (!id || !entity || !entity.hasOwnProperty(activeProperty)) {
    console.log(
      "Invalid params, please check the values of id / entity or activeProperty in method onToggleListItem"
    );
    return;
  }

  let property = otherProperty ? otherProperty : activeProperty;
  const clonedEntity = { ...entity };
  delete clonedEntity[activeProperty];
  let newEntity;
  if (!binary) {
    newEntity = {
      ...clonedEntity,
      [property]: !entity[activeProperty],
    };
  } else {
    const data = new FormData();
    data.append(
      "entity",
      new Blob(
        [
          JSON.stringify({
            ...clonedEntity,
            [property]: !entity[activeProperty],
          }),
        ],
        {
          type: "application/json",
        }
      )
    );
    newEntity = data;
  }

  try {
    if (beforePromise) {
      this.setState({ loading: true, result: false });
      const beforePromiseResponse = await beforePromise;
      if (
        beforePromiseResponse &&
        beforePromiseResponse.response &&
        (beforePromiseResponse.response.status !== 200 ||
          beforePromiseResponse.response.status !== 201)
      ) {
        this.setState({
          loading: false,
          result: false,
          error: buildError({
            error: beforePromiseResponse,
            status: beforePromiseResponse.response.status,
            message: beforePromiseResponse.response.data,
            operation: "update",
          }),
        });
        return;
      }
      this.setState({ loading: false, result: false });
    }
    await sendRequest({
      options: {
        url: restConfig.update.url({ id, entity, ...this.appContext }),
        method: restConfig.update.method,
        data: newEntity,
        headers: restConfig.update.headers || {}
      },
      reloadEntities: true,
      resetCache: restConfig.update.resetCache,
    });
  } catch (error) {
    console.log("onToggleListItem error");
    console.log(error);
    this.setState({ error });
  }
}

//When on list view, when the delete button is triggered
//this function is executed. it removes the entity from the list.
//It does so by making a delete request to the API,
//which if successful triggers a reload of the
//entities for the list. if not successful it shows an error.
async function onDeleteListItem({ id, entity, restConfig, sendRequest, callback, beforePromise }) {
  //FIXME remove when call to legacy endpoint no longer needed
  if (callback) {
    callback(this.state);
  }

  if (beforePromise) {
    const beforePromiseResponse = await beforePromise;
    if (
      beforePromiseResponse &&
      beforePromiseResponse.response &&
      (beforePromiseResponse.response.status !== 200 ||
        beforePromiseResponse.response.status !== 201)
    ) {
      return beforePromiseResponse;
    }
  }

  if (!id || !entity) {
    console.log(
      "Invalid params, please check the values of id / entity in method onDeleteListItem"
    );
    return;
  }
  try {
    const result = await sendRequest({
      options: {
        url: restConfig.delete.url(entity, this.state.entity.hotelTicker),
        method: restConfig.delete.method,
        data: entity,
        headers: restConfig.delete.headers || {}
      },
      reloadEntities: true,
      resetCache: restConfig.delete.resetCache,
    });
    this.setState({
      result,
      action: "delete",
    });
  } catch (error) {
    console.log("onDeleteListItem error");
    console.log(error);
    this.setState({
      error: buildError({
        error,
        status: error && error.response && error.response.status,
        message: error && error.response && error.response.data,
        operation: "delete",
      }),
      result: false,
    });
  }
}

function buildError({ error, operation, status, message }) {
  let code = "UNEXPECTED";
  const extraInfo = {};
  if (code !== null) {
    switch (status) {
      case 409:
        code = "CONFLICT";
        if (
          error &&
          error.response &&
          error.response.headers.location &&
          error.response.headers.location
        ) {
          extraInfo.conflictingEntity = error.response.headers.location.split("/").pop();
        }
        break;
      default:
        console.log("no error status");
    }
    return {
      code,
      extraInfo,
      operation,
      status,
      message,
      error,
    };
  }
  return null;
}

//When on form view, when the submit button is triggered
//this function is executed. it submits the entity .
//It does so by making a POST/PUT request to the API,
//if and id already exists it uses a PUT request to update
//if not, a POST is used to create the new entity
//if successful triggers a redirect to the entities list
//if not successful it shows an error.
async function onSubmitEntity({
  id,
  entity,
  restConfig,
  sendRequest,
  hotelTicker,
  entityName,
  history,
  requestQueueBeforeMain,
  requestQueueAfterMain,
  beforePromise,
  dataReload,
}) {
  if (!entity) {
    console.log("Invalid params, please check the values of id / entity in method onSubmitEntity");
    return;
  }
  let operation = "create";
  if (beforePromise) {
    this.setState({ loading: true, result: false });
    const beforePromiseResponse = await beforePromise;
    if (
      beforePromiseResponse &&
      beforePromiseResponse.response &&
      (beforePromiseResponse.response.status !== 200 ||
        beforePromiseResponse.response.status !== 201)
    ) {
      this.setState({
        loading: false,
        result: false,
        error: buildError({
          error: beforePromiseResponse,
          status: beforePromiseResponse.response.status,
          message: beforePromiseResponse.response.data,
          operation,
        }),
      });
      return;
    }
    this.setState({ loading: false, result: false });
  }
  let result = null;
  try {
    if (requestQueueBeforeMain) {
      await requestQueueBeforeMain(sendRequest);
    }

    if (this.state.entity.id || id) {
      operation = "update";
      result = await sendRequest({
        options: {
          url: restConfig.update.url({ id, ...entity, ...this.appContext }),
          method: restConfig.update.method,
          data: entity,
          headers: restConfig.update.headers || {}
        },
        reloadEntities: false,
        resetCache: restConfig.update.resetCache,
      });
    } else {
      result = await sendRequest({
        options: {
          url: restConfig.create.url({ ...entity, ...this.appContext }),
          method: restConfig.create.method,
          data: entity,
          headers: restConfig.create.headers || {}
        },
        reloadEntities: false,
        resetCache: restConfig.create.resetCache,
      });
    }

    if (requestQueueAfterMain) {
      await requestQueueAfterMain(result, sendRequest);
    }

    const newState = {
      result,
      operation,
      error: null,
    };

    if (result.data) {
      newState.entity = result.data;
    }

    this.setState(newState);
    history.push(getListPath({ hotelTicker, entityName, state: true }));
    if (dataReload) dataReload();
  } catch (error) {
    console.log("onSubmitEntity error");
    console.log(error);
    this.setState({
      error: buildError({
        error,
        status: error && error.response && error.response.status,
        message: error && error.response && error.response.data,
        operation,
      }),
      result: false,
    });
  }
}

async function onCloneListItem({
  history,
  appContext,
  entityName,
  entity,
  clearFields,
  restConfig,
  api,
}) {
  //Fetch the entity
  const value = await fetchEntity({ entity, restConfig, api });
  delete value["id"];
  delete value["ticker"];
  if (clearFields) {
    clearFields.forEach(field => {
      delete value[field];
    });
  }
  const jsonValue = JSON.stringify(value);
  window.sessionStorage.setItem("duplicate", jsonValue);
  window.sessionStorage.setItem("duplicateEntityName", entityName);
  return history.push(`/${appContext.hotelTicker}/${entityName}/new`);
}

async function onSortListItem({
  id,
  swappedId,
  entity,
  field,
  newIndex,
  swappedEntity,
  oldIndex,
  restConfig,
  sendRequest,
  binary,
}) {
  let firstEntity;
  let secondEntity;
  if (!binary) {
    firstEntity = { ...entity, [field.fieldName]: newIndex };
    secondEntity = { ...swappedEntity, [field.fieldName]: oldIndex };
  } else {
    const data1 = new FormData();
    const data2 = new FormData();
    data1.append(
      "entity",
      new Blob([JSON.stringify({ ...entity, [field.fieldName]: newIndex })], {
        type: "application/json",
      })
    );
    data2.append(
      "entity",
      new Blob([JSON.stringify({ ...swappedEntity, [field.fieldName]: oldIndex })], {
        type: "application/json",
      })
    );
    firstEntity = data1;
    secondEntity = data2;
  }
  try {
    await sendRequest({
      options: {
        url: restConfig.update.url({ id, ...firstEntity, ...this.appContext }),
        method: restConfig.update.method,
        data: firstEntity,
      },
      reloadEntities: false,
      resetCache: false,
    });
    await sendRequest({
      options: {
        url: restConfig.update.url({
          id: swappedId,
          ...secondEntity,
          ...this.appContext,
        }),
        method: restConfig.update.method,
        data: secondEntity,
      },
      reloadEntities: true,
      resetCache: true,
    });
  } catch (error) {
    console.log("onSortListItem error");
    console.log(error);
  }
}

async function onReorderListItem({ id, afterId, restConfig, sendRequest }) {
  try {
    await sendRequest({
      options: {
        url: restConfig.reorder.url({ id, afterId, ...this.appContext }),
        method: restConfig.update.method,
        data: null,
      },
      reloadEntities: true,
      resetCache: true,
    });
  } catch (error) {
    console.log("onReorderListItem error");
    console.log(error);
  }
}

//sends request to API in order to fetch all entities of a given type
//TODO: consider pagination
async function fetchEntities({ appContext, restConfig, api }) {
  const entities = await api.request({
    url: restConfig.fetch.url(appContext),
    method: restConfig.fetch.method,
    headers: restConfig.fetch.headers || {}
  });
  const fields = entities.data && entities.data[restConfig.dataField];
  if (fields) {
    return fields;
  }

  const { hotelTicker } = appContext;
  let finalEntities = entities.data;

  if (finalEntities.length > 0 && !finalEntities[0].propertyTicker) {
    finalEntities = finalEntities.map(entity => ({
      ...entity,
      propertyTicker: hotelTicker,
    }));
  }
  return finalEntities;
}

async function resetCache({ appContext, restConfig, api }) {
  const { hotelTicker } = appContext;
  const result = await api.request({
    url: `${restConfig.resetCacheURL || restConfig.baseURL}/api/property/${hotelTicker}/cache`,
    method: "POST",
  });
  return result.data;
}

//sends request to API in order to fetch an specific entity
async function fetchEntity({ entity, restConfig, api }) {
  const entities = await api.request({
    url: restConfig.fetch.url(entity),
    method: restConfig.fetch.method,
    headers: { ...api.headers, ...restConfig.fetch.headers }
  });
  return entities.data;
}

//sends request to API in order to fetch an specific entity
async function fetchRelatedEntities({
  entity,
  restConfig,
  appContext,
  globalEntityConfiguration,
  entityConfiguration,
}) {
  const relatedEntities = {};

  for (let idx = 0; idx < entityConfiguration.relatedEntities.length; idx++) {
    const relatedEntityName = entityConfiguration.relatedEntities[idx].name;
    const relatedEntityConfiguration = globalEntityConfiguration[relatedEntityName];

    const api = request.create({
      baseURL: relatedEntityConfiguration.restConfig.baseURL,
    });

    const response = await api.request({
      url: relatedEntityConfiguration.restConfig.fetch.url({
        propertyTicker: appContext.hotelTicker,
      }),
      method: relatedEntityConfiguration.restConfig.fetch.method,
    });
    relatedEntities[relatedEntityName] = response.data;
  }

  return relatedEntities;
}

//it sets loading == true when request starts and
//loading == false when loading ends (either successfully or with errors)
async function sendAPIRequest({ options = {}, api, reloadEntities, resetCache, ignoreState }) {
  // TODO: SECURE REQUESTS
  const token = "token";
  if (!token) {
  }
  if (!ignoreState) {
    this.setState({ loading: true, result: false });
  }
  try {
    const newState = { loading: false };
    const result = await api.request(options);
    if (reloadEntities) {
      newState.entities = await this.fetchEntities();
    }
    if (resetCache) {
      try {
        await this.resetCache();
      } catch (e) {
        console.log("Could not reset cache");
        console.log(e);
      }
    }
    if (!ignoreState) {
      this.setState(newState);
    }
    return result;
  } catch (error) {
    console.log("sendAPIRequest error");
    console.log(error);
    if (!ignoreState) {
      this.setState({ loading: false });
    }
    throw error;
  }
}

function handleCreate({ event, history, hotelTicker, entityName, entity }) {
  return history.push(`/${hotelTicker}/${entityName}/new`);
}

function handleEdit({ event, history, hotelTicker, entityName, entity }) {
  return history.push(`/${hotelTicker}/${entityName}/${entity.id}`);
}

function getListPath({ hotelTicker, entityName, state }) {
  return `/${hotelTicker}/${entityName}/${state ? "success" : ""}`;
}

function resetResult() {
  this.setState({ result: false, error: false });
}

const defaultMethods = {
  onToggleListItem,
  onDeleteListItem,
  fetchEntities,
  resetCache,
  fetchRelatedEntities,
  fetchEntity,
  sendAPIRequest,
  onSubmitEntity,
  onSortListItem,
  onCloneListItem,
  onReorderListItem,
  handleCreate,
  handleEdit,
  getListPath,
  resetResult,
};
/*TODO: Define which parts of the config object can be static or defined at runtime */
function asRestEntity(WrappedComponent, overriddenMethods = {}) {
  const {
    onToggleListItem,
    onDeleteListItem,
    onSubmitEntity,
    onSortListItem,
    onCloneListItem,
    onReorderListItem,
    fetchEntities,
    fetchRelatedEntities,
    fetchEntity,
    sendAPIRequest,
    handleCreate,
    handleEdit,
    getListPath,
    resetCache,
    resetResult,
  } = {
    ...defaultMethods,
    ...overriddenMethods,
  };
  const result = class extends React.Component {
    constructor(props, context) {
      super(props, context);

      if (!props.config || !props.config.restConfig) {
        throw new Error(
          "Improperly Configured: " +
            "make sure your config property is defined " +
            "with a restConfig attribute object "
        );
      }

      //Creating API instance
      const { restConfig, entityName } = props.config;
      const api = request.create({
        baseURL: restConfig.baseURL,
      });

      //build pre-configured methods through currying and entity configuration
      const { hotelTicker, history, id } = this.props;

      this.appContext = {
        hotelTicker,
        propertyTicker: hotelTicker,
      };

      this.sendAPIRequest = ({ options, entity, reloadEntities, ...rest }) =>
        sendAPIRequest.bind(this)({
          restConfig,
          options,
          api,
          entity,
          reloadEntities,
          ...rest,
        });
      this.onToggleListItem = ({ id, entity, activeProperty, ...rest }) =>
        onToggleListItem.bind(this)({
          id,
          entity,
          activeProperty,
          restConfig,
          sendRequest: this.sendAPIRequest,
          ...rest,
        });

      this.onDeleteListItem = ({ id, entity, beforePromise, callback }) =>
        onDeleteListItem.bind(this)({
          id,
          entity,
          restConfig,
          sendRequest: this.sendAPIRequest,
          //FIXME remove when call to legacy endpoint no longer needed
          callback,
          beforePromise,
        });

      this.onSubmitEntity = ({
        id,
        entity,
        requestQueueBeforeMain,
        requestQueueAfterMain,
        beforePromise,
      }) =>
        onSubmitEntity.bind(this)({
          id,
          entity,
          restConfig,
          hotelTicker,
          entityName,
          history,
          requestQueueBeforeMain,
          requestQueueAfterMain,
          beforePromise,
          dataReload: this.props.wbkData.reload,
          sendRequest: this.sendAPIRequest,
        });

      this.onCloneListItem = ({ entity, clearFields }) =>
        onCloneListItem.bind(this)({
          appContext: this.appContext,
          clearFields,
          history,
          entityName,
          entity,
          restConfig,
          api,
        });

      this.onSortListItem = ({
        id,
        swappedId,
        entity,
        field,
        newIndex,
        swappedEntity,
        oldIndex,
        binary,
      }) =>
        onSortListItem.bind(this)({
          id,
          swappedId,
          entity,
          field,
          newIndex,
          swappedEntity,
          oldIndex,
          restConfig,
          sendRequest: this.sendAPIRequest,
          onSubmitEntity: this.onSubmitEntity,
          binary,
        });

      this.onReorderListItem = ({ id, afterId }) =>
        onReorderListItem.bind(this)({
          id,
          afterId,
          restConfig,
          sendRequest: this.sendAPIRequest,
          onSubmitEntity: this.onSubmitEntity,
        });

      this.fetchEntities = () =>
        fetchEntities.bind(this)({
          appContext: this.appContext,
          restConfig,
          api,
        });

      this.resetCache = () =>
        resetCache.bind(this)({
          appContext: this.appContext,
          restConfig,
          api,
        });

      this.fetchRelatedEntities = params =>
        fetchRelatedEntities.bind(this)({
          appContext: this.appContext,
          restConfig,
          ...params,
        });

      this.fetchEntity = ({ entity }) =>
        fetchEntity.bind(this)({
          appContext: this.appContext,
          restConfig,
          api,
          entity,
        });

      this.handleCreate = ({ entity } = {}) =>
        handleCreate.bind(this)({
          hotelTicker,
          entityName,
          entity,
          history,
        });

      this.handleEdit = ({ event, entity }) =>
        handleEdit.bind(this)({
          event,
          hotelTicker,
          entityName,
          entity,
          history,
        });

      this.getListPath = ({ entity }) =>
        getListPath.bind(this)({
          hotelTicker,
          entityName,
          entity,
        });
      this.resetResult = resetResult.bind(this);

      this.state = {
        entities: [],
        entity: {
          hotelTicker,
          ticker: id,
          propertyTicker: hotelTicker,
          id,
        },
        loading: false,
        result: false,
      };
    }

    updateEntity = ({ action, entityProperties, value }) => {
      let entity = this.state.entity;

      updateObjectByPath({
        action,
        object: entity,
        path: entityProperties,
        value,
      });

      this.setState({ entity });
    };

    loadDuplicateEntity(props) {
      const dup = window.sessionStorage.getItem("duplicate");
      const dupType = window.sessionStorage.getItem("duplicateEntityName");
      window.sessionStorage.removeItem("duplicate");
      window.sessionStorage.removeItem("duplicateEntityName");
      return dup && dupType === props.entityName ? JSON.parse(dup) : null;
    }

    async componentDidMount() {
      let entities = [];
      this.setState({ loading: true });

      if (this.props.type === "LIST") {
        try {
          entities = await this.fetchEntities();
          this.setState({ loading: false, entities });
        } catch (error) {
          console.log("RestEntityHOC componentDidMount error");
          console.log(error);
          this.setState({
            error: buildError({
              error,
              status: error && error.response && error.response.status,
              message: error && error.response && error.response.data,
              operation: "fetch",
            }),
            result: false,
            loading: false,
          });
        }
      }

      if (this.props.type === "FORM") {
        const entityConfiguration = this.props.config;
        let relatedEntities = undefined;
        if (
          entityConfiguration.relatedEntities &&
          entityConfiguration.relatedEntities.length >= 0
        ) {
          relatedEntities = await this.fetchRelatedEntities({
            entity: this.state.entity,
            globalEntityConfiguration: this.props.globalEntityConfiguration,
            entityConfiguration: entityConfiguration,
          });
        }

        //Check if we have a duplicate one
        const duplicate = this.loadDuplicateEntity(this.props);
        let entity = duplicate ? duplicate : this.state.entity;

        if (entity && typeof entity.id !== "undefined" && entity.id !== null) {
          try {
            entity = await this.fetchEntity({ entity: entity });
          } catch (error) {
            this.setState({
              error: buildError({
                error,
                status: error && error.response && error.response.status,
                message: error && error.response && error.response.data,
                operation: "fetch",
              }),
              result: false,
              loading: false,
            });
          }
        }

        this.setState({
          loading: false,
          entities,
          entity,
          relatedEntities,
        });
      }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {}

    render() {
      const { hotelTicker, locales } = this.props;
      const { entities, entity, loading, error, result, action, relatedEntities } = this.state;
      const {
        onToggleListItem,
        onDeleteListItem,
        onSubmitEntity,
        handleCreate,
        handleEdit,
        getListPath,
        sendAPIRequest,
        onSortListItem,
        onCloneListItem,
        onReorderListItem,
      } = this;

      return (
        <WrappedComponent
          onToggleListItem={onToggleListItem}
          onDeleteListItem={onDeleteListItem}
          onCloneListItem={onCloneListItem}
          onSubmitEntity={onSubmitEntity}
          onSortListItem={onSortListItem}
          onReorderListItem={onReorderListItem}
          entities={entities}
          relatedEntities={relatedEntities}
          entity={{ ...entity, propertyTicker: hotelTicker }}
          loading={loading}
          hotelTicker={hotelTicker}
          locales={locales}
          entityError={error}
          entityResult={result}
          entityAction={action}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          getListPath={getListPath}
          sendAPIRequest={sendAPIRequest}
          fetchEntities={this.fetchEntities}
          resetResult={this.resetResult}
          updateEntity={this.updateEntity}
          {...this.props}
        />
      );
    }
  };

  return withPropertyData(result);
}

export default asRestEntity;
